import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setLoading(false);
    if (error) return toast.error(error.message);
    setSent(true);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF8F5] p-6">
      <div className="max-w-md w-full bg-white rounded-3xl border border-[#E8E2D9] p-10" data-testid="forgot-page">
        <Link to="/login" className="text-sm text-[#57534E]">← Back to sign in</Link>
        <h1 className="font-display font-bold text-2xl tracking-tight mt-4 mb-2">Reset your password</h1>
        {sent ? (
          <p className="text-sm text-[#57534E]">If that email is registered, a reset link has been sent. Check your inbox.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <p className="text-sm text-[#57534E]">Enter your email and we'll send you a reset link.</p>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="forgot-email" type="email" required value={email}
                     onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
            </div>
            <Button data-testid="forgot-submit" type="submit" disabled={loading}
                    className="w-full rounded-full bg-[#E8712C] hover:bg-[#C55A1F]">
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
